import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  app: Reducer.IAppState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getAppState = (state: IAppState) => state.app;

export const isAppLoading = (state: IAppState) => getAppState(state).loading;

export const isAppReady = (state: IAppState) => getAppState(state).ready;

export const isFocusedMode = (state: IAppState) => getAppState(state).focused;
